module.exports = __webpack_public_path__ + "static/the-inevitable-7ff37576ae1978617bbb5c225b03c658.jpg";